export const resolution = {
  parentalControl: {
    icon: {
      Width: "2rem",
      Height: "2rem"
    },
    title: {
      FontSize: "xmedium",
      Color: "primary"
    },
    description: {
      FontSize: "default",
      Color: "grey"
    }
  },
  devices: {
    icon: {
      Width: "2rem",
      Height: "2rem"
    },
    title: {
      FontSize: "default",
      Color: "grey"
    },
    description: {
      FontSize: "xmedium",
      Color: "primary"
    }
  }
};
